import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { API_END_POINTS } from '../constant/api.constant';
import { Observable, BehaviorSubject, Subject, finalize, debounceTime, timer } from 'rxjs';
import { environment } from '../../environments/environment';
import { SocketService } from './socket.service';
import { PreviousRouteService } from './previous-route.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private userProfileSubject = new BehaviorSubject<any>(null);
  userProfile = this.userProfileSubject.asObservable();
  // Create subject and public observable of user profile data
  private loggedInSubject = new BehaviorSubject<any>(false);
  isLoggedInSub = this.loggedInSubject.asObservable();
  private showSection = new Subject<any>();
  showSection$ = this.showSection.asObservable();

  private deviceTokenSubject = new BehaviorSubject<any>(null);
  deviceToken = this.deviceTokenSubject.asObservable();



  public tabClick: EventEmitter<any> = new EventEmitter();
  public PageName: EventEmitter<any> = new EventEmitter();
  public showRecords: EventEmitter<any> = new EventEmitter();
  public showLogin: EventEmitter<any> = new EventEmitter();

  callValue: EventEmitter<any> = new EventEmitter();
  showCategoryBar: EventEmitter<any> = new EventEmitter();
  private isShowMarketWatch = new BehaviorSubject<any>(false);

  public user;
  public isSeenPopup: any = {
    investpack: '',
    digitalSaving: '',
    mutualFund: '',
    trading: ''
  };
  private isSeenOnborading: any
  private loginOfferDisplay = new BehaviorSubject<boolean>(false)
  private introSlides: any

  private clientTokenSubject = new BehaviorSubject<any>(typeof window !== 'undefined' ? window.localStorage.getItem('clientToken') : '');
  private consentInvestpackSubject = new BehaviorSubject<any[]>([]);
  consentInvestpack = this.consentInvestpackSubject.asObservable();
  constructor(
    private http: HttpClient,
    private router: Router,
    private socketService: SocketService,
    private previousRoute: PreviousRouteService,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    if (typeof window !== 'undefined' && window.localStorage.getItem(environment.tokenKey)) {
      this.user = JSON.parse(window.localStorage.getItem(environment.tokenKey));
    }
  }

  get isLoggedIn(): Observable<any> {
    return this.loggedInSubject.pipe(debounceTime(0))
  }

  getClientToken() {
    return this.clientTokenSubject.value;
  }
  setClientToken(token: any) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('clientToken', token);
      this.clientTokenSubject.next(token);
    }
  }

  public getRewardById(id): Observable<any> {
    return this.http.get(`${API_END_POINTS.WALLET.rewards}/${id}`);
  }

  checkAuth(isRedirect: boolean = false, isUpdate: boolean = false) {
    if (typeof window !== 'undefined') {
      const token = JSON.parse(window.localStorage.getItem(environment.tokenKey));
      if (token) {
        this.loggedInSubject.next(true);
        const user = JSON.parse(window.localStorage.getItem('userProfile'));
        if (user && user.riskProfile && !isUpdate) {
          this.setRiskProfile();
        }
        // this.getUserWallet()
        if (isRedirect) {
          let userVertical = window.localStorage.getItem('userVertical')
          this.router.navigate([userVertical ? `/${userVertical}` : '/investment']);
        }
        if (isUpdate) {
          this.UpdateUserData(isRedirect);
        } else {
          this.userProfileSubject.next(user);
        }
      } else {
        this.loggedInSubject.next(false);
        this.userProfileSubject.next(null);
      }
    }
  }

  logout() {
    if (typeof window !== 'undefined') {
      this.http
        .post(`${API_END_POINTS.INVESTOR.logout}`, {
          platform: environment.app ? 'mobile' : 'web',
        })
        .subscribe((res: any) => {
          const loginFrom = window.localStorage.getItem('loginFrom');
          if (window.localStorage.getItem('isSeenPopup')) {
            this.isSeenPopup = JSON.parse(window.localStorage.getItem('isSeenPopup'))
          }
          if (window.localStorage.getItem('isSeenOnboarding')) {
            this.isSeenOnborading = window.localStorage.getItem('isSeenOnboarding')
          }

          if (window.localStorage.getItem('introSlides')) {
            this.introSlides = window.localStorage.getItem('introSlides')
          }
          window.localStorage.getItem
          window.localStorage.removeItem(environment.tokenKey);
          window.localStorage.clear();
          window.sessionStorage.removeItem("investpackFilter");
          this.previousRoute.clearPreviousUrl()
          this.closeAllSockets();
          this.loggedInSubject.next(false);
          this.userProfileSubject.next(null);
          if (loginFrom === 'AliceBlue') {
            this.router.navigate(['/alice-blue']);
          }
          else if (loginFrom === '5Paisa') {
            this.router.navigate(['/five-paisa']);
          }
          else {
            this.router.navigate(['/']);
          }
          window.localStorage.setItem('isSeenPopup', JSON.stringify(this.isSeenPopup))
          if (this.isSeenOnborading) {
            window.localStorage.setItem('isSeenOnboarding', 'true')
          }
          if (this.introSlides) {
            window.localStorage.setItem('introSlides', this.introSlides)
          }
        });
    }
  }

  saveAccessToken(data: any) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(environment.tokenKey, JSON.stringify(data));
      this.loggedInSubject.next(true);
      this.userProfileSubject.next(data);
    }
  }

  signup(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.AUTH.signin}`, data);
  }

  resendOtp(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.AUTH.resendOtp}`, data);
  }

  sendOtp(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.AUTH.sendOtp}`, data);
  }

  login(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.AUTH.login}`, data);
  }

  getCurrentUser() {
    if (typeof window !== 'undefined') {
      return JSON.parse(window.localStorage.getItem(environment.tokenKey));
    }
  }

  getUserData() {
    return this.userProfileSubject.value;
  }

  getUserProfile(): Observable<any> {
    return this.http.get(`${API_END_POINTS.INVESTOR.users}`);
  }

  UpdateUserData(isRedirect: any): Promise<any> {
    if (typeof window !== 'undefined') {
      return new Promise((resolve, reject) => {
        this.http.get(`${API_END_POINTS.INVESTOR.users}`)
          .pipe(finalize(() => resolve(true)))
          .subscribe((res: any) => {
            res.data.scope = 'investor';
            res.data.baseUrl = res.baseUrl;
            this.userProfileSubject.next(res.data);
            window.localStorage.setItem('userProfile', JSON.stringify(res.data));
            if (res.data.riskProfile) {
              this.setRiskProfile();
            }
            if (isRedirect) {
              this.router.navigate(['/investor']);
            }
          });
      })
    }
  }

  updateProfilePic(pic: any) {
    if (typeof window !== 'undefined') {
      const u = this.userProfileSubject.value;
      u.profileImage = pic;
      this.userProfileSubject.next(u);
      window.localStorage.setItem('userProfile', JSON.stringify(u));
    }
  }

  updateProfileData(data: any) {
    if (typeof window !== 'undefined') {
      this.userProfileSubject.next(data);
      window.localStorage.setItem('userProfile', JSON.stringify(data));
    }
  }

  updateProfileNotificationSound(sound: any) {
    if (typeof window !== 'undefined') {
      const u = this.userProfileSubject.value;
      u.notificationSound = sound;
      this.userProfileSubject.next(u);
      window.localStorage.setItem('userProfile', JSON.stringify(u));
    }
  }


  sendAppLink(data: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.AUTH.sendAppLink}/${data}`);
  }

  contactUs(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.AUTH.contactUs}`, data);
  }

  getTopPerformer(): Observable<any> {
    return this.http.get(`${API_END_POINTS.AUTH.topPerformer}`);
  }

  getAppVersion(platform): Observable<any> {
    return this.http.get(`${API_END_POINTS.VERSION.version}?platform=${platform}`);
  }

  notificationList(query: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.NOTIFICATION.investor}?${query}`);
  }

  notificationCount(): Observable<any> {
    return this.http.get(`${API_END_POINTS.NOTIFICATION.investorCount}`);
  }
  updateCount(): Observable<any> {
    return this.http.put(`${API_END_POINTS.NOTIFICATION.investorCount}`, {});
  }
  setDeviceToken(token: any) {
    this.deviceTokenSubject.next(token);
  }
  getDeviceToken() {
    return this.deviceTokenSubject.value;
  }

  getAllChat(query): Observable<any> {
    return this.http.get(`${API_END_POINTS.CHAT.chat}?${query}`);
  }

  creatCallChat(data): Observable<any> {
    return this.http.post(API_END_POINTS.CHAT.chat, data);
  }

  shareInviteEmail(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.WALLET.referralEmailInvite, data);
  }

  public getFirebaseLink(data): Observable<any> {
    return this.http.post(API_END_POINTS.FIREBASE.dynamic_link, data);
  }

  public getAdvisorComplaints(id): Observable<any> {
    return this.http.get(`${API_END_POINTS.ADVISOR.client_complaints}/${id}`);
  }

  followAdvisor(id: any) {
    return this.http.put(`${API_END_POINTS.INVESTOR.followAdvisor}/${id}`, {});
  }

  verfiyMobileSignIn(): Observable<any> {
    return this.http.get(``);
  }

  getGoogleInfo(token: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.SL.googleDecode}`, {
      token,
    });
  }

  signInWithGoogle(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.SL.googleSignIn}`, data);
  }

  socialLogin(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.SL.socialLogin}`, data);
  }


  forgotPassword(data: any) {
    return this.http.post(`${API_END_POINTS.FORGOTPASSWORD.forgot}`, data);
  }
  createPassword(data: any) {
    return this.http.put(`${API_END_POINTS.FORGOTPASSWORD.forgot}`, data);
  }

  setShowMarketWatch(isShow: boolean) {
    this.isShowMarketWatch.next(isShow);
  }
  getShowMarketWatch() {
    return this.isShowMarketWatch.asObservable();
  }

  setLoggedIn() {
    this.loggedInSubject.next(true);
  }

  getAllInvestPackChat(query: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.CHAT.investPackChat}?${query}`);
  }
  creatInvestPackChat(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.CHAT.investPackChat, data);
  }

  public getClientPortfolio(): Observable<any> {
    return this.http.get(`${API_END_POINTS.CLIENTS.investpacks}`);
  }

  moneyControlEnquiry(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.COMMON.money_control}`, data);
  }
  getBrokerageHouses(): Observable<any> {
    return this.http.get(`${API_END_POINTS.CLIENTS.brokerage_houses}`);
  }

  setRiskProfile() {
    this.http.get(`${API_END_POINTS.INVESTOR.risk_profile}`).subscribe({
      next: (res: any) => {
        this.updateProfileData({ ...this.userProfileSubject.value, riskValue: res.data.riskValue });
      }
    });
  }
  getGlobalVideos(): Observable<any> {
    return this.http.get(`${API_END_POINTS.CLIENTS.videos}`)
  }

  public playAudioAdvisor(type) {
    const audio = new Audio();
    switch (type) {
      case 'TARGET_ONE':
      case 'TARGET_TWO':
        audio.src = 'assets/audio/Target_Hit.mp4';
        break;
      case 'STOP_LOSS':
        audio.src = 'assets/audio/SL_Hit.mp3';
        break;
      case 'ACTIVE':
        audio.src = 'assets/audio/Edit.mp3';
        break;
      default:
        break;
    }
    audio.load();
    audio.addEventListener(
      'canplaythrough',
      () => {
        this.loadedAudio(audio);
      },
      false
    );
  }

  public loadedAudio(audio: HTMLAudioElement) {
    audio.play();
  }

  closeAllSockets() {
    this.socketService.closeSocket()
    //   this.socketService.closeZerodhaSocket()
    //   this.socketService.closeMarketTicks()
    //   this.socketService.closeMarketTicks()
    //   this.socketService.closeHoldingsSocket()
  }

  getAllMFImages(): Observable<any> {
    return this.http.get(API_END_POINTS.MUTUALFUND.amc);
  }

  getUserprofileJourney(investpackId?: string, planId?: any): Observable<any> {
    let _query = planId ? `?planId=${planId}` : '';
    if (investpackId) {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.subscription_flow}/${investpackId}${_query}`)
    } else {
      return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.subscription_flow}${_query}`)
    }
  }

  getVerticals(): Observable<any> {
    return this.http.get(`${API_END_POINTS.CLIENTS.verticals}`);
  }
  checkReward(): Observable<any> {
    return this.http.get(API_END_POINTS.CLIENTS.rewards)
  }

  getReferralDetails(): Observable<any> {
    return this.http.get(`${API_END_POINTS.WALLET.referral_credits}`)
  }

  campaignVisitor(campaignName: string) {
    this.http.put(`${API_END_POINTS.CAMPAIGN.visitor_count}?name=${campaignName}`, {}).subscribe(() => { })
  }

  campaignSignupSub(campaignName: string, isSignup: boolean, isSubscriber: boolean, vertical?: string) {
    let query: string = `name=${campaignName}`
    if (isSignup) {
      query = query.concat(`&signup=1`)
    } else if (isSubscriber && vertical) {
      query = query.concat(`&subscribers=1&vertical=${vertical}`)
    }
    this.http.put(`${API_END_POINTS.CAMPAIGN.signup_subscribe_count}?${query}`, {}).subscribe(() => { })
  }

  getUserCampaign(): Observable<any> {
    return this.http.get(API_END_POINTS.CAMPAIGN.check_campaign)
  }

  checkUserOffers(activity?: 'admin_offers_signup' | 'admin_offers_riskProfiling' | 'admin_offers_paid_subscription'): Observable<any> {
    if (activity) {
      return this.http.get(`${API_END_POINTS.OFFERS.offer_config}?activity=${activity}`)
    } else {
      return this.http.get(`${API_END_POINTS.OFFERS.offer_config}`)
    }
  }

  getCouponReward(couponCode: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.CLIENTS.coupon_reward}?scope=investor&couponCode=${couponCode}`)
  }
  saveDeviceToken(data: any) {
    data.device = data.device == 'Android' ? 'android' : data.device == 'iOS' ? 'ios' : data.device ? 'web' : 'NA';
    this.http.post(API_END_POINTS.AUTH.user_device, data).subscribe((res: any) => {

    });
  }

  getAppLoginFlow(): Observable<any> {
    return this.http.get(API_END_POINTS.AUTH.login_flow)
  }

  checkUserSubscriptions(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR.check_subscription)
  }

  showOffer() {
    this.loginOfferDisplay.next(true)
  }

  isShowOfferPopup(): Observable<any> {
    return this.loginOfferDisplay.asObservable()
  }

  getLiveFeed(): Observable<any> {
    return this.http.get(API_END_POINTS.LIVE_FEED.live_feed)
  }

  getCouponSignupReward(): Observable<any> {
    return this.http.get(API_END_POINTS.WALLET.signUp)
  }
  updateInvestpackConsent(_id: any) {
    let _ic: any[] = this.consentInvestpackSubject.value;
    _ic.push(_id);
    this.consentInvestpackSubject.next(_ic);
  }
  setInvestpackConsent(_id: any[]) {
    this.consentInvestpackSubject.next(_id);
  }
  getInvestpackConsent() {
    return this.http.get(`${API_END_POINTS.INVESTOR_LONGTERM.userConsent}?vertical=investpack`);
  }
  getLinkInfo(id: any, type: any) {
    return this.http.get(`${API_END_POINTS.RM_FLOW.linkInfo}/${id}/${type}`);
  }
  trackLinkInfo(id: any, type: any, action: any) {
    return this.http.get(`${API_END_POINTS.RM_FLOW.trackLinkInfo}/${id}/${type}?action=${action}`);
  }
}
